import { clearUserInfo } from '@/utils'
import { getToken, fetchToken } from './token'
import { createLoading as createPageLoading } from '@/pages/loading/utils/index'

/**
 * 权限校验相关的路由拦截器
 */
export async function initAlphaRouterGuard(to, from, next) {
  console.log('守卫：alpha')
  // 非白名单，没有token要获取token
  let removePageLoading = null
  if (!getToken()) {
    removePageLoading = createPageLoading()
    await fetchToken()
    clearUserInfo()
  }
  removePageLoading && removePageLoading()
}

